'use client';
import { Image } from '@heroui/image';
import { Button } from '@heroui/button';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';
import { Link } from '@heroui/link';
import StoreIcons from '../common/StoreIcons';

export default function Hero() {
  return (
    <>
      <section className="relative z-10 flex items-center justify-center w-full min-h-[550px] h-full bg-primary/10 overflow-hidden ">
        <div className="container flex flex-col items-center justify-center text-center container-max ">
          {/* Content Section */}
          <div className="flex flex-col items-center md:max-w-4xl space-y-8 md:space-y-14">
            <div className="space-y-8">
              {/* <div className="flex items-center justify-center">
                <motion.div
                  initial={{ opacity: 0, y: -50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                  viewport={{ once: true }}
                  className="flex items-center p-1 rounded-full shadow bg-background shadow-black/5"
                >
                  <div className="flex -space-x-2">
                    {[1, 2, 3].map((num) => (
                      <Image
                        key={num}
                        alt={`Agents ${num}`}
                        className="rounded-full ring-2 ring-background"
                        height={24}
                        src={`/images/testimonials/${num}.png`}
                        width={24}
                      />
                    ))}
                  </div>
                  <p className="px-2 text-sm text-foreground/70">
                    Trusted by{' '}
                    <CountUp
                      className="font-medium leading-normal text-primary"
                      duration={5}
                      end={500}
                    />{' '}
                    agents.
                  </p>
                </motion.div>
              </div> */}
              <motion.h1
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.3,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                className="hero-title-lg"
              >
                {/* <span className="text-primary">Earn Money, Grow Faster</span> Become a Super Agent! */}
                Your One-Stop for <span className="text-primary">Banking & Payments</span>
              </motion.h1>

              {/* <p className="mt-4 text-lg md:text-xl">
              Expand Your Network, Earn on Every Transaction!
              </p> */}

              <div className="space-y-4">
               <motion.p
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.4,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                className="max-w-xl mx-auto text-xl text-default-600 md:text-2xl titalic"
              >
                {/* Expand Your Network, Earn on Every Transaction! */}
                Available at PayStop Agents Nationwide
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.5,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                className="flex items-center justify-center"
              >
                <StoreIcons />
              </motion.div>
             </div>
              {/* CTA Button */}
              {/* <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.5,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                className="flex items-center justify-center gap-3"
              >
                <Link href="/become-agent">
                  <Button color={'primary'} radius="full" size="lg">
                    Join as an Agent
                  </Button>
                </Link>
                  
              </motion.div> */}
            </div>

            {/* Partner Logos */}
            {/* <motion.div
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: 0.6,
                ease: 'easeOut',
              }}
              viewport={{ once: true }}
              className="flex flex-wrap items-center justify-center gap-4 pt-4 md:gap-6 "
            >
              {[1, 2, 3, 4, 5, 6].map((num) => (
                <Image
                  key={num}
                  alt={`Partner ${num}`}
                  className="transition-opacity rounded-none opacity-70 hover:opacity-100 grayscale hover:grayscale-0"
                  height={40}
                  src={`/images/logos/${num}.svg`}
                  width={80}
                />
              ))}
            </motion.div> */}
          </div>
        </div>

        {/* Background Design */}
        <div className="absolute inset-0 mx-0 overflow-hidden -z-10 max-w-none">
          <div className="absolute top-0 w-full h-full dark:[mask-image:linear-gradient(white,transparent)]">
            <div
              className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-40
        [mask-image:radial-gradient(farthest-side_at_top,white,transparent)]
        dark:from-primary/50 dark:to-secondary/50 dark:opacity-100 z-10"
            >
              <svg
                aria-hidden="true"
                className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full skew-y-[-15deg] 
          fill-gray-800/40 stroke-gray-900/50 mix-blend-overlay 
          dark:fill-gray-200/10 dark:stroke-gray-300/10"
              >
                <defs>
                  <pattern
                    height="56"
                    id="pattern-grid"
                    patternUnits="userSpaceOnUse"
                    width="72"
                    x="-12"
                    y="4"
                  >
                    <path d="M.5 56V.5H72" fill="none" stroke="currentColor" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect fill="url(#pattern-grid)" height="100%" width="100%" />
              </svg>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
